// extracted by mini-css-extract-plugin
export default {"pageContent":"blogs_pageContent__kUwJW"};